"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function YourGuideThroughTheComplexity() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: leftColRef,
    isVisible: isLeftColVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightColRef,
    isVisible: isRightColVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: signatureRef,
    isVisible: isSignatureVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="your-guide-through-the-complexity" className="relative w-full bg-background pt-12 pb-4 lg:pt-16 lg:pb-8 overflow-hidden flex items-center justify-center min-h-[80vh]">
      <div className="absolute top-1/2 -translate-y-1/2 w-full text-center text-[15vw] font-black text-primary/[0.03] select-none pointer-events-none z-0 whitespace-nowrap tracking-tighter" aria-hidden="true">
        GUIDANCE
      </div>

      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="max-w-5xl mx-auto">
          <div ref={headerRef} className={`text-center mb-16 md:mb-24 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-foreground tracking-tight">
              Your Guide Through the Complexity
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 lg:gap-32 items-start">
            <div ref={leftColRef} className={`space-y-6 transition-all duration-1000 delay-100 ease-out text-left ${isLeftColVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              <div className="w-12 h-1 bg-primary/20 mb-6 rounded-lg" />
              <h3 className="text-2xl font-serif text-foreground">Clinical Clarity</h3>
              <p className="text-lg text-muted-foreground leading-relaxed">
                I provide detailed review and explanation of medical records,
                including PSA trends, biopsy results, MRI findings, and pathology
                reports. I translate complex clinical information into clear,
                understandable language and identify whether additional testing may
                help better define your overall disease risk.
              </p>
            </div>

            <div ref={rightColRef} className={`space-y-6 transition-all duration-1000 delay-300 ease-out ${isRightColVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              <div className="w-12 h-1 bg-primary/20 mb-6 rounded-lg" />
              <h3 className="text-2xl font-serif text-foreground">Empowered Decisions</h3>
              <p className="text-lg text-muted-foreground leading-relaxed">
                I help patients make complex decisions, including when active
                surveillance may be appropriate and when treatment may be worth
                considering. I also help clarify conflicting recommendations from
                different providers so you can move forward with greater confidence
                and, when needed, identify second opinion resources that align with
                your goals.
              </p>
            </div>
          </div>

          <div ref={signatureRef} className={`mt-16 md:mt-24 flex flex-col items-center md:items-end transition-all duration-1000 delay-500 ease-out ${isSignatureVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <p className="font-serif text-4xl text-foreground/90 italic tracking-wide">
              Paul Arangua, MPH
            </p>
            <p className="text-sm text-muted-foreground mt-3 uppercase tracking-widest font-medium">
              Prostate Cancer Epidemiologist
            </p>
          </div>
        </div>
      </div>
    </section>;
}